<template>
  <v-container :fluid="true" class="page_container">
    <div class="partner__title">
      <span class="partner__title--text">
        Уведомление от "{{getMailsDetail?.partner.name}}"
      </span>
    </div>
    <div class="partner__container" v-if="getMailsDetail !== null && !isLoading">
      <div class="partner__top_name">
        {{ getMailsDetail.subject }}
      </div>
      <div
          class="partner__back"
          @click.stop="returnParent"
      >
        <v-icon size="24" class="font-weight-bold">west</v-icon>
      </div>
      <div class="partner__logo">
        <v-img
            v-if="getMailsDetail.partner.logo"
            alt="placeholder_partner"
            max-width="80%"
            max-height="300"
            aspect-ratio="1"
            :src="getFileLink(getMailsDetail.partner.logo.link)"
        />
      </div>
      <div class="partner__text">
        <span v-html="checkLink(getMailsDetail.body)">
        </span>
      </div>
    </div>
    <div v-else-if="getMailsDetail === null && !isLoading">
      <NoData/>
    </div>
    <div class="partner__container" v-else>
      <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
        <fulfilling-square-spinner
            :animation-duration="4000"
            :size="100"
            color="#34347C"
        />
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import helper from "@/urls/helper"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "MailsDetail",
  components: {
    NoData,
    FulfillingSquareSpinner
  },
  data () {
    return {
      isLoading: true,
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getMailsDetail: 'personal_account/mails/getMailsDetail'
    }),
  },
  methods: {
    ...mapActions({
      loadMailsDetail: 'personal_account/mails/loadMailsDetail',
    }),
    checkLink (str) {
      // eslint-disable-next-line
      const REGEXP_LINK = /\b((?:https?:\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'\".,<>?«»“”‘’]))|(\[[^\]]+\([^\)]+\))/gmi
      const REGEXP_HTML_A = /<a.*?>.*?<\/a.*?>/si
      const regexLink = new RegExp(REGEXP_LINK)
      const regexLinkTag = new RegExp(REGEXP_HTML_A)
      const matches = str.match(regexLinkTag)
      if (matches !== null) {
        return str
      }
      let link = str
      link = link.replace(regexLink, (match, offset) => {
        return "<a href=" + offset + " target='_blank'" + ">" + offset + "</a>"
      })
      return link
    },
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    },
    returnParent () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: names.MAIL.PAGE })
    },
    loadData (url = undefined) {
      this.loadMailsDetail({
        id: this.$route.params.id,
        finalizer: () => {
          this.isLoading = false
        },
        catcher: () => {}
      })
    },
  },
  beforeMount () {
    if (window.scrollY !== 0) {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      this.loadData()
    }
  }
})
</script>

<style scoped lang="scss">
.partner__title {
  display: flex;
  justify-content: space-between;
}

.partner__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.partner__container {
  position: relative;
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 50px;
}

.partner__content {
  display: flex;
  position: relative;
}

.partner__top_name {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  padding: 0 50px;
  max-width: 70%;
  height: 50px;
  background-color: #3254B9;
  border-radius: 5px 0;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
}

.partner__back {
  content: "";
  display: inline-flex;
  position: absolute;
  right: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background: #376FFE;
  border-radius: 5px;
  cursor: pointer;
}

.partner__logo {
  display: inline-flex;
  align-content: center;
  justify-content: center;
  margin-top: 50px;
}

.partner__text {
  margin-top: 50px;
  font-style: normal;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .partner__title {
    margin-top: 20px;
  }

  .partner__container {
    padding: 20px;
  }

  .partner__top_name {
    font-size: 16px;
    line-height: 19px;
    padding: 10px 20px;
    min-height: 50px;
    height: inherit;
  }

  .partner__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }
}
</style>
